<template>
  <l-cache :get-data="getItem" :id="$route.params.id" ref="cache">
    <reservation-group-content :data="data" :tab-prop="tab" slot-scope="{data}" @refresh="$refs.cache.retry()" @changeTab = "changeTab">
      <template slot="title-actions">
        <v-btn @click="$refs.cache.retry()" class="mx-0" color="primary" flat>刷新</v-btn>
      </template>
    </reservation-group-content>
  </l-cache>
</template>
<script>

import ReservationGroupContent from './groupContent'

export default {
  name: 'ReservationGroupDetails',
  components: {ReservationGroupContent},
  data () {
    return {
      tab: 0
    }
  },
  methods: {
    async getItem (key) {
      let {items} = await this.$store.dispatch('reservation/getReservationGroups', {
        pagination: {},
        search: {key: 'id', value: key},
        locate: this.$route.query.history ? 'history' : 'runtime'
      })
      //console.log(items)
      if (items.length) {
        let item = items[0]
        item.editInfo = false
        item.loading = false
        //console.log(item)
        return item
      }
      else {
        this.$L.alert('error', '未找到该预约分组')
      }
    },
    changeTab (data) {
      this.tab = data
    }
  }
}
</script>

<style scoped>

</style>
